import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React from 'react';
import { TimeUnit } from 'types/common';

type IIntervalSelectProps = {
	options: TimeUnit[];
	initialValue: string;
	onChange: (e: SelectChangeEvent<string>) => void;
	name?: string;
	disabled?: boolean;
};

const IntervalSelect: React.FC<IIntervalSelectProps> = ({
	options,
	initialValue,
	onChange,
	name,
	disabled
}) => {
	const handleChange = (event: SelectChangeEvent) => {
		onChange(event);
	};

	// create unit items
	const unitItems = options.map((option) => (
		<MenuItem key={option} value={option}>
			{intl.tr(`time.interval.${option}`)}
		</MenuItem>
	));

	return (
		<Select
			value={initialValue}
			onChange={handleChange}
			fullWidth
			name={name}
			disabled={disabled}
		>
			{unitItems}
		</Select>
	);
};

IntervalSelect.defaultProps = {
	name: undefined,
	disabled: false
};

export default IntervalSelect;
